export default "__VITE_ASSET__B1uU6GQd__"